import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/funnel/$id/_layout-funnel/product-index')({
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  // TODO: implement or remove
  return <div>Product Index route</div>;
}
